module.exports = __webpack_public_path__ + "img/menu4-2.19085a4b.svg";